import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DiagnosticResult, SsoPendingResponse } from '../models/diagnostic.models';
import { StoreAuxService } from '../../services/storeAux/store-aux.service';

@Injectable()
export class DiagnosticService {
  private readonly basePath = '/brands/finances-trm/ads';

  constructor(private readonly http: HttpClient, private readonly storeAux: StoreAuxService) {}

  diagnose(
    campaignId: string,
    country: string,
    storeId: string,
    storeType: string,
    campaignType: string,
    keyword: string | null
  ): Observable<DiagnosticResult> {
    return this.http.post<DiagnosticResult>(this.storeAux.getCountry(`${this.basePath}/diagnose`, country), {
      campaign_id: campaignId,
      country,
      store_id: storeId,
      store_type: storeType,
      campaign_type: campaignType,
      keyword: keyword || null
    });
  }

  getSsoPending(): Observable<SsoPendingResponse> {
    return this.http.get<SsoPendingResponse>(this.storeAux.getCountry(`${this.basePath}/sso-pending`));
  }
}
